export default __webpack_public_path__ + "static/media/cp_geo_th.1366e19e.svg";